import APIService from '@/services/APIService.js';

export default {
  consultar(objDatasCodigos) {
    return APIService.apiCall().post('/modulosAneel/consultar', JSON.stringify(objDatasCodigos), { responseType: 'blob' });
  }
};
